export const prioritizeNudgeTextTemplate = "bdKoec";
export const prioritizeNudgeTextBold = "gmMbB";
export const prioritizeNudgeTextDescription = "hIPSEc";
export const prioritizeNudgeTextDescriptionOnDelivery = "CFZiKc";
export default {prioritizeNudgeTextTemplate,prioritizeNudgeTextBold,prioritizeNudgeTextDescription,prioritizeNudgeTextDescriptionOnDelivery};